export default __webpack_public_path__ + "static/media/928.a7f3a336.jfif";